module.exports = "/learn-more-hero-image-c025ba90b897b9b67a21acecd44128fe.jpg";